import React, { Component } from 'react';
import classNames from 'classnames';
import Router from 'next/router';
import { Button } from '../components/Generic/Button';
import languages from '../constants/languages';
import { BreadcrumbItem, Breadcrumb } from '../components/Generic/Breadcrumb';
import PageMetadata from '../components/Generic/PageMetadata';
import Typography from '../components/Generic/Typography';
import styles from '../components/Brand/ErrorPage/ErrorPage-tw-styles';
import DOMIdentifier from '../utils/domIdentifier';

class NotFoundPage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    DOMIdentifier.addClassToBody('page-not-found');
  }

  componentWillUnmount() {
    DOMIdentifier.removeClassToBody('page-not-found');
  }
  render() {
    const defaultLanguage = languages.defaultLangKey;
    const i18nMessages = require(`../constants/messages/${defaultLanguage}`);

    return (
      <React.Fragment>
        <PageMetadata
          title={i18nMessages.pageNotFoundMetaTitle}
          metaTitle={i18nMessages.pageNotFoundMetaTitle}
          metaDescription={i18nMessages.pageNotFoundMetaDescription}
          orgTitle={i18nMessages.pageNotFoundMetaTitle}
          orgDescription={i18nMessages.pageNotFoundMetaDescription}
        />
        <div className={classNames(styles.wrapperBreadcrumb)}>
          <Breadcrumb component="ul" className={classNames(styles.breadcrumb)}>
            <BreadcrumbItem
              component="li"
              className={classNames(styles.breadcrumbItem)}
              linkClassName={classNames(styles.breadcrumbItemLink)}
              labelText={i18nMessages.homeLabel}
              to={`/${languages.defaultLangKey.toLocaleLowerCase()}`}
              keyIndex={0}
              key={0}
            />
          </Breadcrumb>
        </div>
        <div className={classNames(styles.mainWrapper)}>
          <div className={styles.pageContentWrapper}>
            <div className={styles.pageTitleContainer}>
              <Typography component="h1" className={styles.pageTitleContent}>
                {i18nMessages.errorPage}
              </Typography>
            </div>
            <div className={styles.pageDescriptionContainer}>
              <Typography
                component="h2"
                className={styles.pageDescriptionContent}
              >
                {i18nMessages.notFoundPage}
              </Typography>
            </div>
            <Button
              className={styles.goBackButton}
              onClick={() => Router.back()}
            >
              {i18nMessages.previousPage}
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default NotFoundPage;
